import { combineReducers }  from 'redux';

import products from './products';
import productDetails from './productDetails';
import user from './user';

export default combineReducers({
  products,
  productDetails,
  user
});



// WEBPACK FOOTER //
// ./src/app/reducers/index.js